var _a, _b, _c, _d, _e, _f, _g, _h;
const Envs = {
  BFF_WEB_URL: (_b = (_a = process.env['NEXT_PUBLIC_HUB_API']) !== null && _a !== void 0 ? _a : process.env['REACT_APP_HUB_API']) !== null && _b !== void 0 ? _b : process.env['NX_BFF_WEB_URL'],
  APP_HOST: (_d = (_c = process.env['NEXT_PUBLIC_APP_URL']) !== null && _c !== void 0 ? _c : process.env['REACT_APP_APP_URL']) !== null && _d !== void 0 ? _d : process.env['NX_APP_URL'],
  COOKIE_DOMAIN: (_f = (_e = process.env['NX_COOKIE_DOMAIN']) !== null && _e !== void 0 ? _e : process.env['REACT_APP_COOKIE_DOMAIN']) !== null && _f !== void 0 ? _f : process.env['NEXT_PUBLIC_COOKIE_DOMAIN'],
  SITE_URL: (_h = (_g = process.env['NEXT_PUBLIC_SITE_URL']) !== null && _g !== void 0 ? _g : process.env['REACT_APP_SITE_URL']) !== null && _h !== void 0 ? _h : process.env['NX_SITE_URL']
};

export { Envs };
